import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import ComponenteService from '../../../../services/componentes'
import Componente from './componente';
import '../../../../styles/diario.scss';
import FormBusca from './busca';
import { Navigate } from 'react-router-dom';


const ComponentesScreen = () => {

    const [componentes, setComponentes] = useState([]);
    const [componentesOriginais, setComponentesOriginais] = useState([]);
    const [editar, setEditar] = useState(false);
    const [vazio, setVazio] = useState(false);
    const [componente, setComponente] = useState("");
    const [loading, setLoading] = useState(false);

    async function fetchComponentes() {
        setLoading(true);
        const response = await ComponenteService.listar();
        if (response.data.length >= 1) {
            setComponentes(response.data);
            setComponentesOriginais(response.data);
            setLoading(false);
            setVazio(false);
        } else {
            setLoading(false);
            setComponentes([]);
            setComponentesOriginais([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (nome, tipo, categoria) => {

        // Se todos vazios → voltar ao original
        if (!nome.trim() && !tipo.trim() && !categoria.trim()) {
            setComponentes(componentesOriginais);
            setVazio(false);
            return;
        }

        const filtrados = componentesOriginais.filter(f => {

            const matchNome = nome.trim()
                ? f.nome.toLowerCase().includes(nome.toLowerCase())
                : true;

            const matchCategoria = categoria.trim()
                ? String(f.categoria).includes(categoria)
                : true;

            const matchTipo = tipo.trim()
                ? f.tipo.toLowerCase().includes(tipo.toLowerCase())
                : true;

            return matchNome && matchCategoria && matchTipo;
        });

        if (filtrados.length >= 1) {
            setComponentes(filtrados);
            setVazio(false);
        } else {
            setComponentes([]);
            setVazio(true);
        }
    };

    const handleEditar = (id) => {
        setComponente(id);
        setEditar(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir o Componente?')) {
            try {
                await ComponenteService.deletar(id)
                alert("Componente deletado com sucesso!")
                fetchComponentes();
            } catch (err) {
                alert("Algo deu errado ao deletar o Componente!")
            }
        }
    }

    useEffect(() => {
        fetchComponentes();
    }, []);

    if (editar) {
        return (
            <Navigate to={`/ti/componentes/editar/${componente}`} />
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Fragment>
                        <FormBusca
                            fetchComponentes={fetchComponentes}
                            filtrarLocalmente={filtrarLocalmente}
                        />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br />
                            <Table className="table table-bordered tabela-rh">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Categoria</th>
                                        <th>Tipo</th>
                                        <th>Descrição leiga</th>
                                        <th>Editar</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {componentes.map((componente, index) =>
                                        <Componente
                                            fetchComponentes={fetchComponentes}
                                            componente={componente}
                                            key={index}
                                            editar={handleEditar}
                                            deletar={deletar}
                                        />
                                    )}
                                </tbody>
                            </Table>
                            {loading && (
                                <Container className="text-center mt-5">
                                    <div className="d-flex justify-content-center">
                                        <div className="spinner-border" role="status" />
                                    </div>
                                    <p className="mt-3">⏳ Carregando dados, aguarde...</p>
                                </Container>

                            )}
                        </Fragment>}
                </Container>
            </Fragment>

        )
    }
}

export default ComponentesScreen;